// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xScreen } from "@ces/XDL/Utilities";
import { quickOrderStyles } from "@insite/content-library/Widgets/Basic/QuickOrder";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

quickOrderStyles.productSelector = {
    container: { gap: 10 },
    searchGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            position: relative;
        `,
    },
    qtyGridItem: {
        width: [6, 2, 2, 1, 1],
        css: css`
            min-width: max-content;
        `,
    },
    unitOfMeasureGridItem: { width: [6, 4, 2, 2, 2] },
    buttonGridItem: {
        width: [12, 5, 2, 2, 2],
        css: css`
            justify-content: flex-end;
            align-items: flex-end;
            white-space: nowrap;
            min-width: max-content;
        `,
    },
    selectButton: {
        css: css`
            &&& {
                min-height: 37px;
                margin-top: 0;
                margin-bottom: 0;
            }
            ${xScreen("lte", "xs")} {
                &&& {
                    margin-top: 21px;
                    width: 100%;
                }
            }
        `,
    },
    clearIcon: {
        size: 18,
        css: css`
            position: absolute;
            right: 35px;
            top: 35px;
            cursor: pointer;
        `,
    },
};

quickOrderStyles.titleGridItem = {
    width: [12, 12, 5, 5, 5],
    css: css`
        padding-bottom: 16px;
    `,
};

quickOrderStyles.linksGridItem = {
    width: [12, 12, 7, 7, 7],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding-bottom: 20px;
                    padding-top: 0;
                `,
                css`
                    padding-bottom: 20px;
                    padding-top: 0;
                `,
                css`
                    justify-content: flex-end;
                    padding-top: 20px;
                `,
                css`
                    justify-content: flex-end;
                    padding-top: 20px;
                `,
                css`
                    justify-content: flex-end;
                    padding-top: 20px;
                `,
            ])}
    `,
};

quickOrderStyles.orderMultipleItemsLink = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
    },
    css: css`
        margin-left: 20px;
    `,
};

quickOrderStyles.orderUploadLink = {
    typographyProps: {
        size: 12,
        weight: "bold",
    },
};
